<template>
    <ul class="form-section-controller-wrapper" v-if="validSections.length > 1">
        <li v-for="(section, index) in validSections" class="mr-1" :class="{active: currentSection === section, 'theme-tinted-background': currentSection === section}" ref="sectionItems" :key="index" @click="scrollToSection(section)">
            {{section.label}}
        </li>
    </ul>
</template>

<script>
import RootStore from '../../stores/root';
import { mapGetters  } from 'vuex';
import _ from 'lodash';

export default {
    store: RootStore,
    props: {
        formPaddingTop: {
            required: true,
            type: String
        }
    },
    data() {
        return {
            currentSection: null,
            lastScrollY: null,
            scrollingSectionLocked: false,
            sectionYRangeMap: []
        }
    },
    watch: {
        currentSection() {
            if (this.currentSection) {
                this.scrollToCurrentSectionItem();
            }
        },
        validSections() {
            // wait for question to mount before really re-calculate
            this.$nextTick(() => this.calculateSectionYRangeMap());
        },
        groupMap() {
            // wait for question to mount before really re-calculate
            this.$nextTick(() => this.calculateSectionYRangeMap());
        },
    },
    computed: {
        ...mapGetters({
            validSections: 'question-sections/validSections',
			groupMap: 'item-groups/groupMap',
        })
    },

    mounted() {
        window.addEventListener('scroll', this.onScroll);
        this.calculateSectionYRangeMap();
    },

    methods: {
        getOffsetYToDocumentForElement(element) {
            var yRelativeToDocument = 0;
            while (element) {
                yRelativeToDocument += element.offsetTop;
                element = element.offsetParent;
            }
            return yRelativeToDocument;
        },
        calculateSectionYRangeMap() {
            const result = [];
            for(var i = 0 ; i < this.validSections.length ; i++) {
                const current = this.validSections[i];
                if (!current.ref) {
                    // If there's section without ref, just break.
                    break;
                }

                let start, end;
                if (i == 0) {
                    start = this.getOffsetYToDocumentForElement(current.ref.$el || current.ref);;
                } else {
                    const previousRange = result[i - 1];
                    start = previousRange.end;
                }

                if (i === this.validSections.length - 1) {
                    end = Infinity;
                } else {
                    const next = this.validSections[i + 1];
                    const nextEl = next.ref.$el || next.ref;
                    end = this.getOffsetYToDocumentForElement(nextEl);
                }
                result[i] = { start, end };
            }
            this.sectionYRangeMap = result;
        },
        onScroll() {
            if (this.lastScrollY === null) {
                this.lastScrollY = window.scrollY;
                return;
            }
            if (this.scrollingSectionLocked) {
                return;
            }

            let formPaddingTop = 0;
            if ($('.brief').length > 0) {
                // traditional form with brief for service datetime/member
                formPaddingTop = $('.brief').get(0).clientHeight + $('.brief').offset().top;
            } else {
                // new form
                formPaddingTop = $(document.querySelector('.top-bar-container')).get(0).clientHeight;
            }
            const sortedSections = this.sectionYRangeMap.sort((a, b) => {
                return a.start - b.start;
            });
            this.currentSection = null;
            for (let i = 0 ; i < sortedSections.length ; i++) {
                const sectionRange = this.sectionYRangeMap[i];
                const adjustedScrollY = formPaddingTop + window.scrollY;
                if (adjustedScrollY >= sectionRange.start && adjustedScrollY <= sectionRange.end) {
                    this.currentSection = this.validSections[i];
                    break;
                }
            }

            this.lastScrollY = window.scrollY;
        },
        scrollToCurrentSectionItem() {
            if (!this.currentSection || !this.$refs.sectionItems) {
                return;
            }

            const sectionItems = this.$refs.sectionItems;
            const index = this.validSections.indexOf(this.currentSection);
            if (index === -1) {
                return;
            }

            if (sectionItems && sectionItems[index]) {
                sectionItems[index].scrollIntoView({
                    inline: 'center', behavior: 'smooth'
                });
            }
        },
        scrollToSection(section) {
            const formPaddingTop = $(document.querySelector('.top-bar-container')).get(0).clientHeight;
            let targetEl;
            if (section.ref.scrollIntoView) {
                targetEl = section.ref;
            } else if (section.ref.$el.scrollIntoView) {
                targetEl = section.ref.$el;
            }

            if (targetEl) {
               var elementTop = $(targetEl).offset().top;
                var targetY = elementTop - formPaddingTop - 12;
                window.scrollTo({
                    top: targetY,
                    behavior: "smooth"
                }); 
            }


            this.currentSection = section;
            this.scrollingSectionLocked = true;
            setTimeout(() => {
                this.scrollingSectionLocked = false;
            }, 1200);
        },
    },
}
</script>

<style scoped lang="scss">
.form-section-controller-wrapper {
    margin: 0;
    margin-left: -24px;
    margin-right: -24px;
    padding: 6px 12px 8px;
    overflow: auto;
    white-space: nowrap;
    text-align: center;
    

    li {
        margin: 4px 0px;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
        padding: 4px 12px;
        cursor: pointer;
        word-break: keep-all;
        font-size: 14px;
        border-radius: 12px;
        background: #F3F3F3;
        display: inline-block;

        color: #0F4555;
    }
}
</style>